import { createSelector } from 'reselect';
import ItemOverviewV2Columns
  from '../../containers/ItemOverviewV2Columns';
import ReportsDefinition from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.ITEM_OVERVIEW_V2_201.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.ITEM_OVERVIEW_V2_201.isLoading;

export const getData =
  ReportsDefinition.ITEM_OVERVIEW_V2_201.getDataFunction();

export const getColumns =
  createSelector(getData, ItemOverviewV2Columns);
